import GIF from 'gif.js.optimized'
import { gifProps, greenScreen } from '.'
import { MediaFrame } from '../../../types'
import { renderGif } from './render'

export async function getGifFromFrames(frames: MediaFrame[], isSticker: boolean = false): Promise<File> {
    const { canvas } = frames[0]

    const gif = new GIF({
        ...gifProps,
        transparent: isSticker ? '0x00ff00' : undefined,
        height: canvas.height,
        width: canvas.width,
    })

    frames.forEach(({ canvas, delay }) => {
        let frame = canvas

        if (isSticker) {
            frame = document.createElement('canvas')
            const frameContext = frame.getContext('2d')
            frame.width = canvas.width
            frame.height = canvas.height
            frameContext?.drawImage(canvas, 0, 0)
            greenScreen(frame)
        }

        gif.addFrame(frame, { delay: Math.round(delay * 1000) })
    })

    return renderGif(gif)
}
